import * as React from "react";
import {
    List,
    Datagrid,
    TextField,
    EditButton,
    Edit,
    Create,
    SimpleForm,
    TextInput,
    ReferenceInput,
    SelectInput,
    DateField,
    DateInput,
    ReferenceField,
    SelectField
} from 'react-admin';

export const PartyMemberList = props => (
    <List {...props}>
        <Datagrid rowClick="edit">
            <TextField source="id" />
            <TextField source="Name" label="姓名" />
            <TextField source="Phone" label="手机号" />
            <ReferenceField source="OrganizationId" reference="Organization" label="所属组织">
                <TextField source="Name" />
            </ReferenceField>
            <SelectField source="Status" label="状态" choices={[
                { id: 0, name: '正常' },
                { id: 1, name: '流出' },
                { id: 2, name: '其它' },
            ]} />
            <DateField source="JoinDate" label="入党时间" />
            <EditButton />
        </Datagrid>
    </List>
);



export const PartyMemberEdit = props => (
    <Edit {...props}>
        <SimpleForm>
            <TextInput disabled source="id" />
            <TextInput source="Name" label="姓名" />
            <TextInput source="IdCard" label="身份证号" />
            <TextInput source="Phone" label="手机号" />
            <ReferenceInput source="OrganizationId" reference="Organization" label="所属组织">
                <SelectInput optionText="Name" />
            </ReferenceInput>
            <SelectInput source="Status" label="状态" choices={[
                { id: 0, name: '正常' },
                { id: 1, name: '流出' },
                { id: 2, name: '其它' },
            ]} />
            <SelectInput source="Gender" label="性别" choices={[
                { id: '男', name: '男' },
                { id: '女', name: '女' },
            ]} />
            <TextInput source="Ethnicity" label="民族" />
            <TextInput source="Education" label="学历" />
            <DateInput source="JoinDate" label="入党时间" />
        </SimpleForm>
    </Edit>
);

export const PartyMemberCreate = props => (
    <Create {...props}>
        <SimpleForm>
            <TextInput source="Name" label="姓名" />
            <TextInput source="IdCard" label="身份证号" />
            <TextInput source="Phone" label="手机号" />
            <ReferenceInput source="OrganizationId" reference="Organization" label="所属组织">
                <SelectInput optionText="Name" />
            </ReferenceInput>
            <SelectInput source="Status" label="状态" choices={[
                { id: 0, name: '正常' },
                { id: 1, name: '流出' },
                { id: 2, name: '其它' },
            ]} />
            <SelectInput source="Gender" label="性别" choices={[
                { id: '男', name: '男' },
                { id: '女', name: '女' },
            ]} />
            <TextInput source="Ethnicity" label="民族" />
            <TextInput source="Education" label="学历" />
            <DateInput source="JoinDate" label="入党时间" />
        </SimpleForm>
    </Create>
);
